import { render, staticRenderFns } from "./PilulaGrupoServico.vue?vue&type=template&id=cf91b522&scoped=true"
import script from "./PilulaGrupoServico.vue?vue&type=script&lang=js"
export * from "./PilulaGrupoServico.vue?vue&type=script&lang=js"
import style0 from "./PilulaGrupoServico.vue?vue&type=style&index=0&id=cf91b522&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf91b522",
  null
  
)

export default component.exports